// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?v=" + {"9152":"0d6e6ad9db6c53cb1a0a","9504":"24ddb98ef6a90c3a6b8a"}[chunkId] + "";
};